<template>
  <ContentBox 
    topBj="linear-gradient(135deg, #ff6b6b 0%, #ee5a52 100%)"
    contentBj="#f5f7fa"
    :footerShow="true"
    title="个人中心"
    :leftShow="false">
    <slot>
      <div class="userInfo-container"> 
        <div class="infoTop"> 
          <div class="avatar-wrapper">
            <img src="@/assets/images/my.png" alt="" class="avatar">
          </div>
          <div class="user-info">
            <div class="titleName">{{userInfo.userName}}</div>
            <div class="subtitle">{{userInfo.adminName}}</div>
          </div>
        </div>

        <div class="card-section">
          <div class="card-item">
            <div class="card-header">
              <van-icon name="user-o" class="header-icon" />
              <span class="header-title">基本信息</span>
            </div>
            <div class="info-grid">
              <div class="info-item">
                <div class="info-label">统一社会信用代码</div>
                <div class="info-value">{{ providerInfo.creditCode ? providerInfo.creditCode : '未填写' }}</div>
              </div>
              <div class="info-row">
                <div class="info-item half-width">
                  <div class="info-label">法人代表</div>
                  <div class="info-value">{{ providerInfo.legalPerson ? providerInfo.legalPerson : '未填写' }}</div>
                </div>
                <div class="info-item half-width">
                  <div class="info-label">注册资本</div>
                  <div class="info-value">{{ providerInfo.registerCapital ? providerInfo.registerCapital : '未填写' }}</div>
                </div>
              </div>
              <div class="info-item">
                <div class="info-label">注册地址</div>
                <div class="info-value">{{ providerInfo.registerAddress ? providerInfo.registerAddress : '未填写' }}</div>
              </div>
            </div>
          </div>

          <div class="card-item" v-if="providerInfo.bankList && providerInfo.bankList.length">
            <div class="card-header">
              <van-icon name="card-o" class="header-icon" />
              <span class="header-title">银行信息</span>
            </div>
            <div class="bank-list">
              <div class="bank-header">
                <div class="bank-col">银行名称</div>
                <div class="bank-col">银行卡号</div>
              </div>
              <div v-for="item in providerInfo.bankList" :key="item.id" class="bank-row">
                <div class="bank-col bank-name">{{item.accountName}}</div>
                <div class="bank-col bank-number">{{item.accountNo}}</div>
              </div>
            </div>
          </div>

          <div class="card-item" v-if="providerInfo.contactList && providerInfo.contactList.length">
            <div class="card-header">
              <van-icon name="friends-o" class="header-icon" />
              <span class="header-title">联系人信息</span>
            </div>
            <div class="contact-list">
              <div class="contact-header">
                <div class="contact-col">名称</div>
                <div class="contact-col">手机号</div>
                <div class="contact-col">邮箱</div>
              </div>
              <div v-for="item in providerInfo.contactList" :key="item.id" class="contact-row">
                <div class="contact-col contact-name">{{item.contactName}}</div>
                <div class="contact-col contact-phone">{{item.phone}}</div>
                <div class="contact-col contact-email">{{item.email}}</div>
              </div>
            </div>
          </div>

          <div class="card-item" v-if="providerInfo.businessLicense && providerInfo.idcardBack && providerInfo.idcardFront">
            <div class="card-header">
              <van-icon name="certificate" class="header-icon" />
              <span class="header-title">资质证件</span>
            </div>
            <div class="document-grid">
              <div class="document-item" v-if="providerInfo.businessLicense">
                <div class="document-label">营业执照</div>
                <div class="document-img" @click="ImagePreview([providerInfo.businessLicense])">
                  <van-image
                    width="100%"
                    height="100%"
                    fit="cover"
                    :src="providerInfo.businessLicense"
                  />
                </div>
              </div>
              <div class="document-item" v-if="providerInfo.idcardFront">
                <div class="document-label">法人身份证(人像)</div>
                <div class="document-img" @click="ImagePreview([providerInfo.idcardFront])">
                  <van-image
                    width="100%"
                    height="100%"
                    fit="cover"
                    :src="providerInfo.idcardFront"
                  />
                </div>
              </div>
              <div class="document-item" v-if="providerInfo.idcardBack">
                <div class="document-label">法人身份证(国徽)</div>
                <div class="document-img" @click="ImagePreview([providerInfo.idcardBack])">
                  <van-image
                    width="100%"
                    height="100%"
                    fit="cover"
                    :src="providerInfo.idcardBack"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="logout-section">
          <van-button 
            type="danger" 
            @click="show = true" 
            block
            round
            class="logout-btn"
          >
            退出登录
          </van-button>
        </div>
      </div>

      <van-action-sheet
        v-model="show"
        :actions="actions"
        cancel-text="取消"
        close-on-click-action
        @cancel="onCancel"
        @select="onConfirmOut"
        class="logout-action-sheet"
      />
    </slot>
    <template #footer> 
      <FooterNav/>
    </template> 
  </ContentBox>
</template>

<script> 
import FooterNav from '@/components/Basic/FooterNav' 
import store from '@/store'
export default {
  name: 'my',
  components: {
    FooterNav
  },
  data() {
    return {
      userInfo: {},
      show: false,
      actions: [{ name: '退出登陆' }],
      providerInfo: {}
    }
  },
  activated() {
    this.userInfo = store.getters
    this.providerInfo = this.userInfo && this.userInfo.provider ? this.userInfo.provider : {}
  },
  created() {
    this.userInfo = store.getters
    this.providerInfo = this.userInfo && this.userInfo.provider ? this.userInfo.provider : {}
  },
  methods:{
    onCancel(){ 
      this.show = false
    },
    onConfirmOut(){
      this.$store.dispatch('user/logout').then((result) => {
        this.$router.push({ path: '/my' });
      });
    },
    ImagePreview(images) {
      // 使用 vant 的 ImagePreview 组件来预览图片
      this.$imagePreview({
        images: images,
        closeable: true
      });
    }
  }
}
</script>

<style lang="less">
.userInfo-container{
  font-size: 0.6rem;
  padding-bottom: 1rem;
  
  .infoTop{
    margin-bottom: 0.5rem; 
    padding: 0.8rem 0;
    box-sizing: border-box;
    text-align: center;
    height: 4.5rem;
    background: linear-gradient(135deg, #ff6b6b 0%, #ee5a52 100%);
    border-radius: 0 0 20px 20px;
    color: white; 
    font-size: 0.43rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: relative;
    overflow: hidden;
    
    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: radial-gradient(circle at 20% 20%, rgba(255,255,255,0.1) 0%, transparent 50%);
    }
    
    .avatar-wrapper {
      margin-bottom: 0.3rem;
      position: relative;
      z-index: 1;
      
      .avatar { 
        height: 1.8rem;
        width: 1.8rem;
        border-radius: 50%;
        border: 3px solid rgba(255,255,255,0.3);
        box-shadow: 0 4px 12px rgba(0,0,0,0.15);
        transition: transform 0.3s ease;
        
        &:hover {
          transform: scale(1.05);
        }
      }
    }
    
    .user-info {
      position: relative;
      z-index: 1;
      
      .titleName { 
        padding: 0.1rem;
        font-weight: 600;
        font-size: 0.6rem;
        margin-bottom: 0.1rem;
        text-shadow: 0 2px 4px rgba(0,0,0,0.1);
      }
      
      .subtitle {
        font-size: 0.38rem;
        opacity: 0.9;
        font-weight: 400;
      }
    }
  }

  .card-section {
    padding: 0 0.4rem;
  }

  .card-item { 
    padding: 0.6rem;
    margin-bottom: 0.4rem;
    background: white;
    border-radius: 12px;
    font-size: 0.42rem;
    line-height: 0.6rem;
    box-shadow: 0 4px 12px rgba(0,0,0,0.05);
    transition: transform 0.2s ease, box-shadow 0.2s ease;
    
    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 6px 20px rgba(0,0,0,0.08);
    }
    
    .card-header {
      display: flex;
      align-items: center;
      margin-bottom: 0.5rem;
      padding-bottom: 0.3rem;
      border-bottom: 1px solid #f0f0f0;
      
      .header-icon {
        font-size: 0.5rem;
        color: #ff6b6b;
        margin-right: 0.2rem;
      }
      
        &:hover {
            border-color: #ff6b6b;
            transform: scale(1.05);
            box-shadow: 0 4px 12px rgba(255, 107, 107, 0.2);
          }
      
      &.contact-phone {
          font-family: 'Courier New', monospace;
          color: #ff6b6b;
        }
        .header-title {
        font-size: 0.48rem;
        font-weight: 600;
        color: #333;
      }
    }
    
    .info-grid {
      .info-item {
        margin-bottom: 0.4rem;
        
        &.half-width {
          flex: 1;
        }
        
        .info-label {
          font-size: 0.38rem;
          color: #999;
          margin-bottom: 0.15rem;
          font-weight: 500;
        }
        
        .info-value {
          font-size: 0.42rem;
          color: #333;
          font-weight: 600;
          word-break: break-all;
        }
      }
      
      .info-row {
        display: flex;
        gap: 0.8rem;
        margin-bottom: 0.4rem;
        
        .info-item {
          margin-bottom: 0;
        }
      }
    }
    
    .bank-list {
      .bank-header {
        display: flex;
        background: #f8f9fa;
        padding: 0.3rem 0.2rem;
        border-radius: 8px;
        margin-bottom: 0.2rem;
        font-weight: 600;
        font-size: 0.38rem;
        color: #666;
      }
      
      .bank-row {
        display: flex;
        padding: 0.3rem 0.2rem;
        border-bottom: 1px solid #f0f0f0;
        transition: background-color 0.2s ease;
        
        &:hover {
          background-color: #f8f9fa;
        }
        
        &:last-child {
          border-bottom: none;
        }
      }
      
      .bank-col {
        flex: 1;
        text-align: center;
        font-size: 0.38rem;
        
        &.bank-name {
          flex: 0.8;
          font-weight: 500;
          color: #333;
        }
        
        &.bank-number {
          font-family: 'Courier New', monospace;
          color: #666;
        }
      }
    }
    
    .contact-list {
      .contact-header {
        display: flex;
        background: #f8f9fa;
        padding: 0.3rem 0.2rem;
        border-radius: 8px;
        margin-bottom: 0.2rem;
        font-weight: 600;
        font-size: 0.38rem;
        color: #666;
      }
      
      .contact-row {
        display: flex;
        padding: 0.3rem 0.2rem;
        border-bottom: 1px solid #f0f0f0;
        transition: background-color 0.2s ease;
        
        &:hover {
          background-color: #f8f9fa;
        }
        
        &:last-child {
          border-bottom: none;
        }
      }
      
      .contact-col {
        flex: 1;
        text-align: center;
        font-size: 0.38rem;
        
        &.contact-name {
          flex: 0.3;
          font-weight: 500;
          color: #333;
        }
        
        &.contact-phone {
          font-family: 'Courier New', monospace;
          color: #667eea;
        }
        
        &.contact-email {
          color: #666;
          font-size: 0.35rem;
        }
      }
    }
    
    .document-grid {
      display: grid;
      grid-template-columns: repeat(auto-fit, minmax(2.8rem, 1fr));
      gap: 0.4rem;
      
      .document-item {
        text-align: center;
        
        .document-label {
          font-size: 0.35rem;
          color: #666;
          margin-bottom: 0.2rem;
          font-weight: 500;
        }
        
        .document-img {
          width: 2.8rem;
          height: 2.8rem;
          margin: 0 auto;
          border: 2px solid #e8e8e8;
          border-radius: 12px;
          overflow: hidden;
          transition: all 0.3s ease;
          cursor: pointer;
          
          &:hover {
            border-color: #667eea;
            transform: scale(1.05);
            box-shadow: 0 4px 12px rgba(102, 126, 234, 0.2);
          }
          
          .van-image {
            width: 100% !important;
            height: 100% !important;
          }
        }
      }
    }
  }

  .logout-section { 
    padding: 0.4rem;
    margin-top: 0.5rem;
    
    .logout-btn {
      background: linear-gradient(135deg, #ff6b6b 0%, #ee5a52 100%);
      border: none;
      font-size: 0.45rem;
      font-weight: 600;
      height: 1.2rem;
      line-height: 1.2rem;
      box-shadow: 0 4px 12px rgba(255, 107, 107, 0.3);
      transition: all 0.3s ease;
      
      &:hover {
        transform: translateY(-2px);
        box-shadow: 0 6px 20px rgba(255, 107, 107, 0.4);
      }
      
      &:active {
        transform: translateY(0);
      }
    }
  }
  
  .logout-action-sheet {
    border-radius: 16px 16px 0 0;
    
    .van-action-sheet__item {
      font-size: 0.42rem;
      height: 1.2rem;
      line-height: 1.2rem;
      
      &:active {
        background-color: #f5f5f5;
      }
    }
    
    .van-action-sheet__cancel {
      color: #666;
      font-weight: 500;
    }
  }
}
</style>